"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
exports.default = satcheljs_1.createStore('conversationsOption', {
    conversationSortOrder: null,
    hideDeletedItems: null,
    globalListViewType: null,
})();
//# sourceMappingURL=store.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-conversations-option/lib/store/store.js
// module id = 2895
// module chunks = 2